import { IsAlphanumeric, IsOptional, Matches, MaxLength, IsNotEmpty } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";

export class CertificationDTO{
     @ApiProperty()
     @IsNotEmpty({message: 'Certification Id should not be empty'})
     @IsAlphanumeric()
     @IsOptional()
     certificationId: number;

     @ApiProperty()
     @IsNotEmpty({message: 'Certification name should not be empty'})
     certification: string;

     @ApiProperty()
     isActive: boolean;

     createdAt: Date;

     @ApiProperty()
     @IsOptional()
     @MaxLength(40, {message: 'Created user allows maximum 40 characters'})
     @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: 'Created User should be only alphabets'})
     createdUser: string;

     updatedAt: Date;

     @ApiProperty()
     @IsOptional()
     @MaxLength(40, {message: 'Updated user allows maximum 40 characters'})
     @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: 'Updated user should be only characters'})
     updatedUser: string;

     @ApiProperty()
     versionFlag: number;
}